export interface Filters {
  page: number;
  items: number;
  callId?: string;
  phone?: string;
  agent?: string;
  patientGuid?: string;
}

export type AppendFilters = (filter: Partial<Filters>) => void;

export const CallTypes = {
  RpmPatientCall: 'patient-call',
  CcmPatientCall: 'ccm-patient-call',
} as const;

export const getCallTypeLabel = (type: CallType) => {
  if (type === CallTypes.RpmPatientCall) {
    return 'RPM';
  }
  if (type === CallTypes.CcmPatientCall) {
    return 'CCM';
  }
  return type;
};

export const CallTypesEnum = Object.values(CallTypes);
export type CallType = (typeof CallTypesEnum)[number];

export interface ICallHistory {
  callId: string;
  patient: {
    guid: string;
    name: string;
    phone: string;
  };
  agent: string;
  type: CallType;
  duration: number;
}

export interface ICallHistoryManagementData {
  count: number;
  items: ICallHistory[];
}

export interface ISplitCall extends Omit<ICallHistory, 'patient'> {
  id: string;
  patientGuid: string;
}

export interface ISplitCallRequest {
  callId: string;
  patientGuid: string;
  type: CallType;
  duration: number;
  calls: {
    patientGuid: string;
    type: CallType;
    duration: number;
  }[];
}

export interface ISplitCallResponse {
  splitCount: number;
  trackCount: number;
}
